export { default } from './Button';



// WEBPACK FOOTER //
// ./src/design-system/atoms/Button/index.jsx